import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useParams,
} from "react-router-dom";
import LoginPage from "./Pages/LoginPage/LoginPage";
import DashboardPage from "./Pages/DashboardPage/DashboardPage";
import ProfilePage from "./Pages/ProfilePage/ProfilePage";
import CalendarPage from "./Pages/CalendarPage/CalendarPage";
import PlatesPage from "./Pages/PlatesPage/PlatesPage";
import AdminPage from "./Pages/AdminPage/AdminPage";
import CreateRestaurantPage from "./Pages/CreateRestaurantPage/CreateRestaurantPage";
import LoginPageAdmin from "./Pages/LoginPageAdmin/LoginPageAdmin";
import { OpenAPI } from "deliziora-client-module/client-web";
import ProtectedRoute from "./util/ProtectedRoute";
import { Provider, useDispatch, useSelector } from "react-redux";
import store from "./redux/store";
import CreateNewRestaurantPage from "./Pages/CreateNewRestaurantPage/CreateNewRestaurantPage";
import Page404 from "./Pages/Page404/Page404";
import InvalidRestaurantTokenPage from "./Pages/Page401/Page401";
import ProtectedRouteWithUUIDCheck from "./util/TokenVerification";
import LayoutRestaurantsPages from "./Pages/LayoutRestaurantsPages/LayoutRestaurantsPages";
import NewDashboardPage from "./Pages/NewDashboardPage/NewDashboardPage";
import { ConfigProvider } from "antd";
import { Auth0Provider } from "@auth0/auth0-react";
import CreateNewRestaurantOAuthPage from "./Pages/CreateNewRestaurantPageOauth/CreateNewRestaurantPageOauth";
import CreateNewRestaurantPageCallback from "./Pages/CreateNewRestaurantPageCallback/CreateNewRestaurantPageCallback";
import CreateNewRestaurantPageCallbackLogin from "./Pages/CreateNewRestaurantPageCallback/CreateNewRestaurantPageCallbackLogin";
import PrivacyPolicy from "./Pages/PolicyPrivacy/PolicyPrivacy";
import TermsOfUse from "./Pages/TermsConditions/TermsConditions";

OpenAPI.BASE = "https://telabite-api-g2c5gbc0hzfddeg9.francecentral-01.azurewebsites.net/";
// OpenAPI.BASE = "http://localhost:8000";

function App() {
  const isSignedIn = localStorage.getItem("userData") ? true : false;
  const isAdmin = localStorage.getItem("adminData") ? true : false;
  return (
    <>
      <ConfigProvider
        theme={{
          components: {
            Checkbox: {
              colorBorder: "#F36528",

            },
          },
        }}
      >
        <Auth0Provider
          domain="dev-zriz501u7oyhck7t.us.auth0.com"
          clientId="JHulCGOLq6ucSMxCiPC1Ua9fkFeuNyTN"
          authorizationParams={{
            redirect_uri: window.location.origin
          }}
        >
          <Provider store={store}>
            <Router>
              <Routes>
                <Route path="/" element={<LoginPage />} />
                <Route path="/login-admin" element={<LoginPageAdmin />} />
                <Route
                  path="/create-restaurant/:uuid"
                  element={
                    <ProtectedRouteWithUUIDCheck>
                      <CreateNewRestaurantPage />
                    </ProtectedRouteWithUUIDCheck>
                  }
                />
                <Route
                  path="/create-restaurant-oauth"
                  element={
                    <CreateNewRestaurantOAuthPage />
                  }
                />
                <Route
                  path="/create-restaurant-callback"
                  element={
                    <CreateNewRestaurantPageCallback />
                  }
                />
                <Route
                  path="/create-restaurant-callback-login"
                  element={
                    <CreateNewRestaurantPageCallbackLogin />
                  }
                />
                <Route path="/401" element={<InvalidRestaurantTokenPage />} />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute isSignedIn={isAdmin} admin={true}>
                      <AdminPage />
                    </ProtectedRoute>
                  }
                />
                {/* <Route
              path="/OLDdashboard"
              element={
                <ProtectedRoute isSignedIn={isSignedIn}>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute isSignedIn={isSignedIn}>
                  <NewDashboardPage />
                </ProtectedRoute>
              }
            /> */}
                <Route
                  path="/home"
                  element={
                    <ProtectedRoute isSignedIn={isSignedIn}>
                      <LayoutRestaurantsPages />
                    </ProtectedRoute>
                  }
                />
                {/* <Route
              path="/profile"
              element={
                <ProtectedRoute isSignedIn={isSignedIn}>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/calendar"
              element={
                <ProtectedRoute isSignedIn={isSignedIn}>
                  <CalendarPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/plates"
              element={
                <ProtectedRoute isSignedIn={isSignedIn}>
                  <PlatesPage />
                </ProtectedRoute>
              }
            /> */}
                <Route path="*" element={<Page404 />} />
                <Route path="/policy-privacy" element={<PrivacyPolicy />} />
                <Route path="/terms-conditions" element={<TermsOfUse />} />
                <Route path="*" element={<Page404 />} />
              </Routes>
            </Router>
          </Provider>
        </Auth0Provider>
      </ConfigProvider>
    </>
  );
}

export default App;
